import * as AssetActions from "./assetActions";

export default AssetActions;



// WEBPACK FOOTER //
// ./src/actions/AssetActions/index.js